export function getSafe<T>(fn: () => T, defaultValue?: T) {
  try {
    return fn();
  } catch (e) {
    return defaultValue;
  }
}
